import * as THREE from 'three'
import React, { Suspense, useEffect, useState, useRef } from 'react'
import { useFrame } from '@react-three/fiber'
import { PerspectiveCamera, Environment, MeshDistortMaterial, ContactShadows, useScroll, useTexture, Html } from '@react-three/drei'
import { useSpring } from '@react-spring/core'
import { a } from '@react-spring/three'
import contil from '../../../img/contil_logo1.png'
import tbf from '../../../img/tbf.png'
import agc from '../../../img/agc.png'
import cp59 from '../../../img/cp59.png'
import wh from '../../../img/wh.png'
import html from '../../../img/HTML_Logo.png'
import css from '../../../img/CSS_Logo.png'
import js from '../../../img/JS_Logo.png'
import nodejs from '../../../img/Nodejs_Logo.png'
import cL from '../../../img/C#_Logo.png'
import netCore from '../../../img/NET_Core_Logo.png'
import postgres from '../../../img/Postgres_Logo.png'
import aF from '../../../img/AF_Logo.png'
import trimbleConnect from '../../../img/Trimble-Connect_Logo.png'
import revit from '../../../img/Revit_Logo.png'
import threejs from '../../../img/Three-js_Logo.png'
import navis from '../../../img/Naviswork_Logo.png'
import teklaStructure from '../../../img/Tekla-Structure_Logo.png'
import avalanche from '../../../img/avalanche-avax-logo.png'
// import {colorType} from './Color'
import { useStore } from '../store'
import { Globals } from "@react-spring/shared";
import TextFloating from './components/TextFloating'
import Cable from './components/Cable'
import ObjectFloating from './components/ObjectFloating'
import ObjectCard from './components/ObjectCard'
import HdrFile from "../../../img/env.hdr";

Globals.assign({
  frameLoop: "always",
});
// React-spring animates native elements, in this case <mesh/> etc,
// but it can also handle 3rd–party objs, just wrap them in "a".
const AnimatedMaterial = a(MeshDistortMaterial)

export default function Scene({ setBg }) {
  const { setPage, project } = useStore()
  const scroll = useScroll()
  const sphere = useRef()
  const light = useRef()
  const [mode, setMode] = useState(false)
  const [down, setDown] = useState(false)
  const [hovered, setHovered] = useState(false)
  const textures = useTexture([
    contil,
    wh,
    tbf,
    agc,
    cp59
  ])
  const [currentPage, setCurrentPage] = useState(0)
  const objectCenter = useRef()
  const object = useRef()
  const object0 = useRef()
  const object1 = useRef()
  const object2 = useRef()
  const object3 = useRef()
  const object4 = useRef()
  const object5 = useRef()
  const object6 = useRef()
  const object7 = useRef()
  const object8 = useRef()
  const object9 = useRef()
  const object10 = useRef()
  const object11 = useRef()
  const object12 = useRef()
  const object13 = useRef()
  const object14 = useRef()
  const object15 = useRef()
  useFrame((state) => {

  })

  // Springs for color and overall looks, this is state-driven animation
  // React-spring is physics based and turns static props into animated values
  const [{ wobble, coat, color, ambient, env, currentTexture }] = useSpring(
    {
      wobble: down ? 1.2 : hovered ? 1.05 : 1,
      coat: mode && !hovered ? 0.04 : 1,
      ambient: mode && !hovered ? 1.5 : 0.5,
      env: mode && !hovered ? 0.4 : 1,
      // color: hovered ? colorType[currentPage][0] : mode ? '#202020' : 'white',
      // config: (n) => n === 'wobble' && hovered && { mass: 2, tension: 1000, friction: 10 },
      currentTexture: textures[currentPage] ? textures[currentPage] : ''
    },
    [mode, hovered, down, currentPage]
  )

  return (
    <>
      <PerspectiveCamera makeDefault position={[0, 0, 25]} fov={75}>
        <a.ambientLight intensity={ambient} />
        <a.pointLight ref={light} position-z={-15} intensity={env} color={'white'} />
      </PerspectiveCamera>
      <Suspense fallback={null}>
        <a.mesh position={[0, 0, 0]} ref={objectCenter} >
          <planeBufferGeometry args={[1.5, 1]} />
          <AnimatedMaterial envMapIntensity={env} clearcoat={coat} clearcoatRoughness={0} metalness={0.001} side={THREE.DoubleSide} opacity={1} transparent />
        </a.mesh>


        <TextFloating ref={object} text={project?.alt} position={[0, 15, 0]} color={project?.color} />



        {project?.tech?.includes('reactjs')
          &&
          <>
            <ObjectFloating ref={object0} url={'https://logos-download.com/wp-content/uploads/2016/09/React_logo_wordmark.png'} size={[2, 1]} position={[-1.5, 2, 0]} />
            <Cable start={objectCenter} end={object0} color={'#6FA8DC'} />
          </>
        }
        {project?.tech?.includes('html')
          &&
          <>
            <ObjectFloating ref={object1} url={html} position={[-1.5, -2, 0]} size={[1, 1]} />
            <Cable start={objectCenter} end={object1} color={'#e44d26'} />
          </>
        }
        {project?.tech?.includes('css')
          &&
          <>
            <ObjectFloating ref={object2} url={css} position={[4.5, -2, 0]} size={[1, 1]} />
            <Cable start={objectCenter} end={object2} color={'#2062af'} />
          </>
        }
        {project?.tech?.includes('js')
          &&
          <>
            <ObjectFloating ref={object3} url={js} position={[-3.5, 2, 0]} size={[1, 1]} />
            <Cable start={objectCenter} end={object3} color={'#e6a329'} />
          </>
        }
        {project?.tech?.includes('netCore')
          &&
          <>
            <ObjectFloating ref={object5} url={netCore} position={[0.5, 2, 0]} size={[1, 1]} />
            <Cable start={objectCenter} end={object5} color={'#5c2d91'} />
          </>
        }
        {project?.tech?.includes('nodejs')
          &&
          <>
            <ObjectFloating ref={object4} url={nodejs} position={[3.5, 2, 0]} size={[1, 1]} />
            <Cable start={objectCenter} end={object4} color={'#5caa46'} />
          </>
        }
        {project?.tech?.includes('postgres')
          &&
          <>
            <ObjectFloating ref={object6} url={postgres} position={[3.5, 2, 0]} size={[2, 1]} />
            <Cable start={objectCenter} end={object6} color={'#265692'} />
          </>
        }
        {project?.tech?.includes('c#')
          &&
          <>
            <ObjectFloating ref={object8} url={cL} position={[3.5, 2, 0]} size={[1, 1]} />
            <Cable start={objectCenter} end={object8} color={'#6a2977'} />
          </>
        }
        {project?.tech?.includes('mongoDB')
          &&
          <>
            <ObjectFloating ref={object7} url={'https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/MongoDB_Logo.svg/2560px-MongoDB_Logo.svg.png'} position={[3.5, 2, 0]} size={[2, 1]} />
            <Cable start={objectCenter} end={object7} color={'#00a453'} />
          </>
        }
        {project?.tech?.includes('aF')
          &&
          <>
            <ObjectFloating ref={object9} url={aF} position={[3.5, 2, 0]} size={[2, 1]} />
            <Cable start={objectCenter} end={object9} color={'#b87720'} />
          </>
        }
        {project?.tech?.includes('revit')
          &&
          <>
            <ObjectFloating ref={object10} url={revit} position={[3.5, 2, 0]} size={[2, 1]} />
            <Cable start={objectCenter} end={object10} color={'#1976d2'} />
          </>
        }
        {project?.tech?.includes('trimbleConnect')
          &&
          <>
            <ObjectFloating ref={object13} url={trimbleConnect} position={[3.5, 2, 0]} size={[2, 1]} />
            <Cable start={objectCenter} end={object13} color={'#005ca7'} />
          </>
        }
        {project?.tech?.includes('navis')
          &&
          <>
            <ObjectFloating ref={object11} url={navis} position={[3.5, 2, 0]} size={[2, 1]} />
            <Cable start={objectCenter} end={object11} color={'#1d8d4a'} />
          </>
        }
        {project?.tech?.includes('threejs')
          &&
          <>
            <ObjectFloating ref={object12} url={threejs} position={[3.5, 2, 0]} size={[1, 1]} />
            <Cable start={objectCenter} end={object12} color={'lightgray'} />
          </>
        }
        {project?.tech?.includes('teklaStructure')
          &&
          <>
            <ObjectFloating ref={object14} url={teklaStructure} position={[3.5, 2, 0]} size={[1, 1]} />
            <Cable start={objectCenter} end={object14} color={'#ac0910'} />
          </>
        }
        {project?.tech?.includes('avalanche')
          &&
          <>
            <ObjectFloating ref={object15} url={avalanche} position={[3.5, 2, 0]} size={[1, 1]} />
            <Cable start={objectCenter} end={object15} color={'red'} />
          </>
        }

        <Environment files={HdrFile} />
        <ContactShadows
          rotation={[Math.PI / 2, 0, 0]}
          position={[0, -1.6, 0]}
          opacity={mode ? 0.8 : 0.4}
          width={15}
          height={15}
          blur={2.5}
          far={1.6}
        />
      </Suspense>
    </>
  )
}
